<div class="language-modal">
  <h1 mat-dialog-title class="title-painel" [translate]="'city-profile/change-cover-photo'">change cover Photo</h1>

  <div class="container">
    <div class="row">
      <!-- <div class="language-container" *ngIf="!loading">
          <button *ngFor="let lang of languages; let i = index" class="language-box language-item menu" (click)="useLanguage(i)">
            <span ngClass="flag-icon flag-icon-{{ lang.flag }}"></span>
            <span>{{lang.name}}</span>
          </button>
        </div> -->

      <!-- <ul> -->
      <!-- <li class="fields-item"> -->
      <!-- <div class="row"> -->
      <!-- <div class="col col-auto">
              <label class="fields-item--label" for="imageUrl" [translate]="'painel-dashboard/cover-photo'">Cover photo</label>
            </div> -->
      <div class="col" *ngIf="loading">
        <app-loading-bar style="margin:auto;text-align: center;"></app-loading-bar>
      </div>
      <div class="col" *ngIf="!loading">
        <div class="ng2FileDrop" ng2FileDrop [ngClass]="{'has-file': hasFile}" (fileOver)="fileOverBase($event)" [uploader]="uploader">
          <i class="icon icon-upload"></i>
          <em [translate]="'painel-dashboard/drag-and-drop'">Drag and drop the image here</em>
          <span class="button">
            <span [translate]="'painel-dashboard/choose-photo'">CHOOSE PHOTO</span>
            <input type="file" ng2FileSelect [uploader]="uploader" id="imageUrl" />
          </span>
          <small class="max-filesize" [translate]="'painel-dashboard/max-filesize'">Maximum file size: 4MB</small>
        </div>

        <div class="upload-files" *ngIf="uploader?.queue && data.basicInfo.image">
          <div class="item">
            <div class="item-card item-cover" *ngIf="hasImage(data.basicInfo.image)">
              <button type="button" (click)="data.basicInfo.image = null"><i class="fa fa-trash"></i></button>
              <a [href]="data.basicInfo.image" target="_blank">
                <img [src]="data.basicInfo.image">
              </a>
            </div>
          </div>
          <ul>
            <li *ngFor="let item of uploader?.queue">
              <div class="row align-items-center">
                <div class="col-sm-7">
                  <span class="name-progress">{{ item?.file?.name }}
                    ({{ item?.file?.size/1024/1024 | number:'.2' }}mb)</span>
                </div>
                <div class="col-sm-4">
                  <div class="mini-progress-bar gray">
                    <div class="mini-progress-bar--inner" [ngStyle]="{ 'width.%' : item.progress }">
                    </div>
                  </div>
                </div>
                <div class="col-sm-1 text-right">
                  <button type="button" (click)="item.remove()"><i class="fa fa-trash"></i><span [translate]="'navigation/cancel'"></span></button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- </div> -->
      <!-- </li> -->
      <!-- </ul> -->
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <button class="btn-painel clear" (click)="onNoClick()" [translate]="'painel-dashboard/back'">Back</button>
</div>